var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLhand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 94,
    viewBox: "0 0 87 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.7416 79.498C43.7416 79.498 43.5163 67.1095 43.7416 59.9016C43.9668 52.6938 44.4173 53.4821 43.7416 50.8918C43.0658 48.3015 41.4891 42.4451 42.1648 37.4896C42.8406 32.5342 43.1037 30.0565 44.0983 28.3672C44.0983 28.3672 46.1066 25.6084 47.7392 26.0021C49.3727 26.3967 51.3432 27.2409 51.3432 27.2409C51.3432 27.2409 51.963 27.6356 52.1883 29.6628C52.4135 31.69 53.0325 32.7604 53.483 33.7731C53.9335 34.7858 54.1587 39.4042 54.1587 39.4042C54.1587 39.4042 53.9903 40.3611 52.9766 40.4178C51.963 40.4746 50.6116 39.798 49.7664 37.4896C48.9222 35.1813 48.7006 34.2803 48.0789 33.21C47.4572 32.1396 46.9509 31.1827 46.9509 31.1827",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1494 32.929C45.1494 32.929 47.1244 33.6047 48.0794 33.6047",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1689 27.168C51.1689 27.168 52.4709 25.8337 52.8087 25.1579C53.1466 24.4822 54.3296 23.8065 56.8073 23.9758C59.285 24.1452 58.2146 29.7196 58.2146 30.1134C58.2146 30.5071 57.9894 33.0416 58.102 34.9561C58.2146 36.8707 58.5525 38.3907 58.5525 38.3907C58.6651 39.6296 57.8173 40.6134 56.4694 40.7558C54.3296 40.981 54.1602 39.4043 54.1602 39.4043L54.0404 37.5636",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0146 27.2041C53.0146 27.2041 52.9893 27.806 53.0893 29.325C53.1893 30.8513 53.7921 35.1778 53.7921 35.1778",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4423 27.3546C58.4423 27.3546 58.2766 24.3516 58.4423 23.2253",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.168 23.9489C56.168 23.9489 58.5331 20.9342 59.5088 20.5963C60.4846 20.2584 63.2632 19.5079 64.2011 21.6847C65.14 23.8624 64.0885 28.3673 63.8254 30.1314C63.5623 31.8956 63.2245 31.8586 62.8497 34.8616C62.474 37.8646 61.4324 38.9512 60.3756 38.9539C58.7952 38.9584 58.4421 38.0529 58.3799 37.4645",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5229 20.2863V17.1806C62.5229 17.1806 62.7751 14.5524 63.0761 13.3892C63.3761 12.2251 63.4518 8.99692 63.4518 8.32118V3.44055C63.4518 3.44055 63.1517 1.03762 65.0663 1.00068C66.9809 0.963741 67.8441 2.42694 67.8819 5.9561C67.9198 9.48525 68.145 16.0174 68.145 17.8941C68.145 19.7709 67.9576 22.2117 67.9945 25.0642C68.0324 27.9176 67.8441 31.5585 67.9567 33.3604C67.9567 33.3604 68.1072 36.0256 70.247 35.9129C72.3868 35.8003 73.4383 35.2372 74.6393 34.7489C75.8403 34.2605 77.7927 32.6838 80.12 32.5712C82.4472 32.4586 85.4881 32.4964 86.2395 33.9227C86.99 35.3489 85.4511 36.1003 84.3249 36.213C84.3249 36.213 83.086 36.3256 82.2977 36.7382C81.5093 37.1509 80.1957 38.4276 77.9432 39.1412C75.6907 39.8547 73.587 40.8314 72.3859 42.0324C71.1849 43.2334 69.8704 44.0218 68.2567 45.0732C66.6422 46.1247 65.2159 47.8888 64.0518 48.9772C62.8878 50.0656 60.7182 50.7792 60.3767 54.1957C60.0352 57.6122 60.711 70.7891 60.8236 73.2668C60.9362 75.7446 61.7246 81 61.7246 81",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5586 76.293H35V81H16.6992V52.5625H22.5586V76.293Z",
    fill: "url(#paint0_diamond)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2424 69.8929) rotate(88.0754) scale(45.1147 45.0815)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD458",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9BF2E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLhand);
export default __webpack_public_path__ + "static/media/Lhand.d7a1ecb62e7841a440eebd12145b45bf.svg";
export { ForwardRef as ReactComponent };